import classNames from 'classnames'
import React, { HTMLAttributes, ReactNode } from 'react'
import styles from './Text.module.css'

export type TextType =
  | '4xl'
  | '3xl'
  | '2xl'
  | 'xl'
  | 'lg'
  | 'base'
  | 'base-black'
  | 'sm'
  | 'sm-black'
  | 'xs'
  | 'xs-black'

export interface TextProps extends HTMLAttributes<HTMLElement> {
  as: string
  children: ReactNode
  textType: TextType
  semiBold?: boolean
}

export const Text = ({ as, children, className, textType, semiBold, ...props }: TextProps) => {
  const Component = React.createElement(
    as,
    {
      ...props,
      className: classNames(styles['textType-' + textType], semiBold ? styles.semiBold : null, className)
    },
    children
  )
  return Component
}
